<div #containerOuter class="flex flex-col rounded-md bg-ponder-light card-shadow hover:cursor-pointer mb-2 text-faded-90 hover:text-white" [ngClass]="{ 'hidden ' : !isVisible }">
        <div #containerInner class="rounded-md">
            <div class="flex flex-row p-1 pl-2 pr-2">
                <div class="grow font-bold">
                    <a [attr.href]="deckUrl">
                        <div class="w-full h-full">{{ deck.name }}</div>
                    </a>
                </div>
                <div class="flex flex-row gap-2 shrink p-1">
                    @if (isOwnDecks) {
                        <deck-favorite [deck]="deck"></deck-favorite>
                        <deck-copy [deck]="deck" class="stroke-faded-50 hover:stroke-faded-90"></deck-copy>
                        <deck-edit-options [deck]="deck" class="stroke-faded-50 hover:stroke-faded-90"></deck-edit-options>
                        <deck-delete [deckId]="deck.id!" [deckName]="deck.name!" class="stroke-faded-50 hover:stroke-faded-90"></deck-delete>
                    } @else if (isAuthed) {
                        <deck-copy [deck]="deck" class="stroke-faded-50 hover:stroke-faded-90"></deck-copy>
                    }
                </div>
            </div>
            <div>
                <a [attr.href]="deckUrl">
                    <div class="flex flex-row gap-2 text-xs p-1 pl-2 pr-2">
                        <div>{{ deck.game }}</div>
                        <div>|</div>
                        <div>{{ deck.type }}</div>
                        <div>|</div>
                        @if (isOwnDecks) {
                            <div>{{ deck.visibility }}</div>
                            <div>|</div>
                        }
                        <div>
                            <span title="Updated {{ getUpdatedAt() }}, Created {{ getCreatedAt() }}">
                                {{ getUpdatedAt() }}
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
</div>